(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["blog-share"] && !Shopify.designMode) return;
  try {
    // Delegated, so blocks re-rendered by the theme editor need no re-binding.
  if (!window.shareBlockCopyReady) {
    window.shareBlockCopyReady = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.share-block__copy');
      if (!button) return;

      var url = button.dataset.shareUrl;
      var status = button.querySelector('[data-share-copy-status]');

      function confirmCopied() {
        button.classList.add('is-copied');
        if (status) status.textContent = 'Link copied';
        clearTimeout(button.copyTimer);
        button.copyTimer = setTimeout(function () {
          button.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 2000);
      }

      // The clipboard API needs a secure context, so fall back to a temporary
      // field for http storefronts and older browsers.
      function legacyCopy() {
        var field = document.createElement('textarea');
        field.value = url;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:absolute;left:-9999px;top:0;';
        document.body.appendChild(field);
        field.select();
        try {
          document.execCommand('copy');
          confirmCopied();
        } catch (error) {
          window.prompt('Copy this link:', url);
        }
        document.body.removeChild(field);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(confirmCopied).catch(legacyCopy);
      } else {
        legacyCopy();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
